"use client";

import * as React from "react";
import { Check, ArrowRight, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pricingTiers = [{
  id: 1,
  title: "The Hong Kong Offsite",
  price: "2D1N",
  description: "2 days, fully managed.\nDay 1: strategy / workshop.\nDay 2: immersive experience (junk, hike, or culture trail), debrief.\nHotels, F&B, transfers — all included."
}, {
  id: 2,
  title: "Global Team Reunite",
  price: "2-5 days itinerary",
  description: "3-5 days fully managed.\xA0\nDay 1: strategy / workshop / Sunset cruise.\nDay 2: immersive experience (cultural workshop, hike, or signtseeing).\nDay 3: Disneyland or Ocean Park\nDay 4 Debrief & leisure. Hotels, F&B, transfers — all included."
}, {
  id: 3,
  title: "Build your own",
  price: "\xA0A-La Carte",
  description: "Choose between number of days\nAnd types of activities from the extensive menu\nLet your team vote"
}];
const tierFeatures = [{
  tierId: 1,
  feature: "HK-style workshops"
}, {
  tierId: 1,
  feature: "Cultural orientation"
}, {
  tierId: 1,
  feature: "Private local guides"
}, {
  tierId: 1,
  feature: "Traditional tea tasting"
}, {
  tierId: 1,
  feature: "Artisan craft sessions"
}, {
  tierId: 2,
  feature: "Dragon boat racing"
}, {
  tierId: 2,
  feature: "Guided nature hiking"
}, {
  tierId: 2,
  feature: "Outdoor team building"
}, {
  tierId: 2,
  feature: "Island hopping tours"
}, {
  tierId: 3,
  feature: "Luxury yachting"
}, {
  tierId: 3,
  feature: "Private transport"
}, {
  tierId: 3,
  feature: "CSR activity planning"
}, {
  tierId: 3,
  feature: "VIP dinner bookings"
}, {
  tierId: 3,
  feature: "Academic orientations"
}];
export default function Multidayretreatpackages() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: cardsRef,
    isVisible: areCardsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: footerRef,
    isVisible: isFooterVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}